(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	require('imagesloaded');

	var isHighRes = $(window).width() > 759;

	$('.collapsed-items').each(function () {
		var mod = $(this);
		var items = mod.find('.collapsed-items__item');
		var itemContent = mod.find('.collapsed-items__item__content');

		// Set the min height to the tallest item's height
		var tallest = 0;

		mod.imagesLoaded(function () {
			items.each(function () {
				var itemContent = $(this).find('.collapsed-items__item__content');
				var itemHeight = itemContent.outerHeight();

				if (itemHeight > tallest) {
					tallest = itemHeight;
				}
			});

			mod.css('min-height', tallest + 'px');
			mod.css('padding-bottom', (itemContent.filter(':last').outerHeight() - items.filter(':last').outerHeight()) + 'px');
		});

		// Opens the first visible item
		var openFirst = function () {
			items.find('.collapsed-items__item__excerpt').removeClass('open');
			items.filter(':visible').eq(0).find('.collapsed-items__item__excerpt').addClass('open');
		};

		// On page load - select the first item (but not in low res)
		if (isHighRes) {
			openFirst();
		}

		// On click - select clicked item
		items.find('.collapsed-items__item__excerpt').on('click', function (e) {
			var clicked = $(this);

			// Open the clicked item unless it's already open AND it's also a link
			if (!clicked.is('a.open')) {
				e.preventDefault();
				items.find('.collapsed-items__item__excerpt').removeClass('open');
				clicked.addClass('open');
			}
		});

		// When live filter is triggered (the "tabs")
		var liveFilterParent = mod.parents('[data-live-filter]').eq(0);
		var firstTime = true;

		if (liveFilterParent.length) {
			liveFilterParent.on('live-filter', function () {
				if (isHighRes) {
					openFirst();
				}
				else if (!firstTime) {
					openFirst();
				}

				firstTime = false;
			});
		}
	});
})();
